import {useId, useState} from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonBase from "@mui/material/ButtonBase";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import {useSisbagalAppConfig} from "sisbagal/provider";

const SisbagalSectorSelector = () => {
    const {
        consolidated,
        toggleConsolidated,
        toggleSaneamento,
        toggleAbastecemento,
        isSaneamentoVisible,
        isAbastecementoVisible,
    } = useSisbagalAppConfig();

    const [expanded, setExpanded] = useState(true);
    const contentId = useId();

    const getConsolidatedColor = () => {
        return consolidated ? "primary" : "error";
    };

    return (
        <div>
            <ButtonBase
                onClick={() => setExpanded(value => !value)}
                aria-expanded={expanded}
                aria-controls={contentId}
                sx={{
                    width: "100%",
                    minHeight: 50,
                    px: 1,
                    gap: 1,
                    justifyContent: "flex-start",
                    bgcolor: "secondary.light",
                    borderBottom: "1px solid",
                    borderColor: "secondary.main",
                }}
            >
                <Typography variant="h6" sx={{flex: 1, textAlign: "left"}}>
                    Sectores
                </Typography>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ButtonBase>
            <Collapse in={expanded} id={contentId}>
                <Stack sx={{px: 2, py: 1}}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isSaneamentoVisible()}
                                onChange={toggleSaneamento}
                            />
                        }
                        label="Saneamento"
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isAbastecementoVisible()}
                                onChange={toggleAbastecemento}
                            />
                        }
                        label="Abastecemento"
                    />
                    <Divider />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={consolidated}
                                onChange={toggleConsolidated}
                            />
                        }
                        label={
                            <Typography color={getConsolidatedColor()}>
                                Consolidado
                            </Typography>
                        }
                    />
                </Stack>
            </Collapse>
        </div>
    );
};

export default SisbagalSectorSelector;
